function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3359 0.647461H8.66313C7.44883 0.647461 6.46094 1.63535 6.46094 2.84965V3.2417H7.75V2.84965C7.75 2.34614 8.15962 1.93652 8.66313 1.93652H13.3359C13.8394 1.93652 14.249 2.34614 14.249 2.84965V3.2417H15.5381V2.84965C15.5381 1.6354 14.5502 0.647461 13.3359 0.647461Z",
  fill: "#A4B1BC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.6504 11.6475V9.70312H10.3506V11.6475C10.3506 12.0034 10.062 12.292 9.70605 12.292H7.76172V13.5918H9.70605C10.062 13.5918 10.3506 13.8804 10.3506 14.2363V16.1807H11.6504V14.2363C11.6504 13.8804 11.939 13.5918 12.2949 13.5918H14.2393V12.292H12.2949C11.939 12.292 11.6504 12.0035 11.6504 11.6475Z",
  fill: "#A4B1BC"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0 7.80707V18.0767C0 19.6627 1.13287 20.9887 2.63179 21.289V4.59473C1.13287 4.89499 0 6.22105 0 7.80707Z",
  fill: "#A4B1BC"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.3691 4.59473V21.289C20.8681 20.9887 22.0009 19.6627 22.0009 18.0766V7.80707C22.0009 6.22105 20.8681 4.89499 19.3691 4.59473Z",
  fill: "#A4B1BC"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M18.0782 4.53076H3.91992V21.353H18.0782V4.53076ZM15.5269 14.2363C15.5269 14.5922 15.2383 14.8808 14.8824 14.8808H12.938V16.8252C12.938 17.1811 12.6495 17.4697 12.2935 17.4697H9.70463C9.34868 17.4697 9.0601 17.1811 9.0601 16.8252V14.8808H7.11577C6.75981 14.8808 6.47123 14.5922 6.47123 14.2363V11.6474C6.47123 11.2915 6.75981 11.0029 7.11577 11.0029H9.0601V9.05855C9.0601 8.7026 9.34868 8.41402 9.70463 8.41402H12.2935C12.6495 8.41402 12.938 8.7026 12.938 9.05855V11.0029H14.8824C15.2383 11.0029 15.5269 11.2915 15.5269 11.6474V14.2363Z",
  fill: "#A4B1BC"
});

var SvgIllnessicon = function SvgIllnessicon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIllnessicon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/illness.icon.ef1328ed.svg";
export { ForwardRef as ReactComponent };